import Vue from 'vue'
import i18n from '@/libs/i18n'

const moment = require('moment')
require('moment/locale/'+i18n.locale)

Vue.use(require('vue-moment'), {
  moment
})